import { Link } from "react-router-dom";
import { colors, typography } from "../../../design/tokens";

interface BlogPostCardProps {
  slug: string;
  title: string;
  excerpt: string;
  coverImage: string;
  date: string;
}

export function BlogPostCard({
  slug,
  title,
  excerpt,
  coverImage,
  date,
}: BlogPostCardProps) {
  const formattedDate = new Date(date).toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return (
    <Link
      to={`/blog/${slug}`}
      className="group flex flex-col bg-[#1E2024] rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
    >
      {/* Cover Image */}
      <div className="relative w-full h-48 overflow-hidden bg-gray-800">
        <img
          src={coverImage}
          alt={title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
        />
      </div>

      {/* Content */}
      <div className="flex flex-col p-6 flex-1">
        {/* Date */}
        <p className="text-sm text-dark-text-secondary mb-2">
          {formattedDate}
        </p>

        {/* Title */}
        <h3 className="text-xl font-bold text-dark-text mb-3 line-clamp-2 group-hover:text-blue-400 transition-colors">
          {title}
        </h3>

        {/* Excerpt */}
        <p className="text-dark-text-secondary line-clamp-3 flex-1">
          {excerpt}
        </p>

        {/* Read More */}
        <div className="mt-4 font-[600] text-dark-text group-hover:opacity-75 transition-opacity">
          Read more →
        </div>
      </div>
    </Link>
  );
}
